import { useCallback } from 'react';
import { RECAPTCHA_SITE_KEY } from '../config';

/**
 * Custom hook to handle Google reCAPTCHA v3 token generation
 * 
 * @returns {Object} Object containing the executeRecaptcha function
 */
export const useRecaptcha = () => {
  /**
   * Execute reCAPTCHA and get a token for the specified action
   * 
   * @param {string} action - The action name (e.g., 'login', 'register')
   * @returns {Promise<string|null>} The reCAPTCHA token or null if failed
   */
  const executeRecaptcha = useCallback(async (action) => {
    try {
      // Check if grecaptcha is available
      if (typeof window === 'undefined' || !window.grecaptcha) {
        console.warn('⚠️ [reCAPTCHA] grecaptcha is not loaded yet');
        return null;
      }

      // Wait for grecaptcha to be ready
      return new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
          try {
            const token = await window.grecaptcha.execute(
              RECAPTCHA_SITE_KEY,
              { action }
            );
            console.log(`✅ [reCAPTCHA] Token generated for action: ${action}`);
            resolve(token);
          } catch (error) {
            console.error('❌ [reCAPTCHA] Error executing reCAPTCHA:', error);
            resolve(null);
          }
        });
      });
    } catch (error) {
      console.error('❌ [reCAPTCHA] Error in executeRecaptcha:', error);
      return null;
    }
  }, []);

  return { executeRecaptcha };
};

